import { render, staticRenderFns } from "./Visits.vue?vue&type=template&id=18752821&scoped=true&"
import script from "./Visits.vue?vue&type=script&lang=js&"
export * from "./Visits.vue?vue&type=script&lang=js&"
import style0 from "./Visits.vue?vue&type=style&index=0&id=18752821&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18752821",
  null
  
)

export default component.exports